module.exports = __webpack_public_path__ + "static/media/camera-shutter.470b1eba.mp3";